import React from 'react';
import cn from './../../lib/bem';
import { validarNumero } from './../../lib/utils';

import './inputText_component.scss';

const InputTextComponent = (props) => {
  const classes = cn('inputTextComponent');

  const onChangeTipoInput = (value) => {
    if (props.type === 'text') {
      if (value.length > 30) {
        return;
      }
    } else if (props.type === 'number') {
      if (!validarNumero(value) || value.length > 14) {
        return;
      }
    }

    props.inputActionMsg('');
    props.inputAction(value);
  };

  return (
    <div className={classes()} style={{ width: `${props.inputWidth}%` }}>
      {props.type !== 'hidden' && (
        <label className={classes('inputTextLabel')}>{props.inputText}</label>
      )}
      <input
        type={props.type}
        className={
          props.inputMsg === ''
            ? classes('inputTexto')
            : classes('inputTexto inputError')
        }
        style={{ textTransform: props.styleText }}
        name={`txt_${props.inputText}`}
        placeholder={'Ingresar'}
        value={props.inputValue}
        onChange={(e) => onChangeTipoInput(e.target.value)}
        autoComplete="off"
      />
      <label className={classes('inputTextoLabelError')}>
        {props.inputMsg}
      </label>
    </div>
  );
};

export default InputTextComponent;
